import { loadMarketSymbols, loadMarketKlines } from './market_proxy_client';

// Indian mutual fund NAV (AMFI data via the free mfapi.in wrapper). NAV is
// published once a day, so there is no live ticker/WebSocket here — only
// daily (and resampled weekly/monthly) history.
export default {
    symbols: [],

    async loadExchangeInfo() {
        this.symbols = await loadMarketSymbols('amfi');
        return this.symbols;
    },
    async loadKline(symbol, tf, endTime) {
        return loadMarketKlines('amfi', symbol, tf, endTime);
    },
    createWs() {},
    connectWs() {},
    subscribe() {},
    unsubscribe() {},
    destroyWs() {},
};
